import React, { useState } from "react";

import { Popover, Typography, CircularProgress ,Tooltip ,} from "@material-ui/core";
import { FileTextOutlined } from '@ant-design/icons';
import axios from "../../axios";

const IssueTitleCell = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [description, setDescription] = useState(null);
  const [loading, setLoading] = useState(false);


  const handlePopoverOpen = async (event) => {
    setAnchorEl(event.currentTarget);
    setLoading(true); 
    try {
      const response = await axios.get(
        `agilesaas_issue_details?IssueId=eq.${data.IssueIdS || data.IssueId}`
      );
      const fetchedDescription = response.data[0]?.Description || "No description available.";
      const plainText = extractPlainText(fetchedDescription); 
      setDescription(plainText);

    } catch (error) {
      console.error("Error fetching issue details:", error);
      setDescription("Failed to fetch details. Try again later.");
    } finally {
      setLoading(false); 
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setDescription(null); // Clear description for next usage
  };

  const isOpen = Boolean(anchorEl);
  const extractPlainText = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Display the Issue Title */}
      <Tooltip title="Click to view detailed description">
     
      <FileTextOutlined
        style={{
          fontSize: "16px",
          color: "#9b59b6",
          cursor: "pointer",
        }}
        onClick={handlePopoverOpen} 
      />
      </Tooltip>
      <label
        style={{
          whiteSpace: "pre-wrap",
          marginRight: "8px",
          marginLeft:"8px"
        }}
      >
        
        {data.modulelinked
          ? `${data.modulelinked?.FullName} : ${data.IssueTitle}`
          : data.IssueTitle}
      </label>

    
   

    
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
       <div
  style={{
    padding: "15px",
    maxWidth: "320px",
    backgroundColor: "#f9f9f9", 
    border: "1px solid #ddd", 
    borderRadius: "8px", 
    textAlign: "left", 
    display: "flex",
    flexDirection: "column", 
    gap: "10px", 
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", 
  }}
>
  <span
    // variant="subtitle1"
    style={{
      fontWeight: "bold",
      fontSize: "16px", 
      color: "#333",
      textAlign: "left"
     
    }}
  >
    Description
  </span>

  {loading ? (
    <CircularProgress size={20} style={{ alignSelf: "center" }} />
  ) : (
    <Typography
      variant="body2"
      style={{
        fontSize: "14px",
        color: "#555", 
        lineHeight: "1.5", 
      }}
    >
      {description || "No description available."}
    </Typography>
  )}
</div>

      </Popover>
    </div>
  );
};

export default IssueTitleCell;
